// Enum of all object type ids - this should be equal to getobjecttypes
// @see https://test-api.eadm.no/service.asmx?op=getobjecttypes
export enum ObjectTypeId {
    User = 1,
    Department = 2,
    Group = 3,
    Function = 4,
    History = 5,
    Event = 6,
    System = 7,
    FormData = 8,
    Message = 9,
    Ruleset = 10,
    FunctionAlias = 11,
    ExternalContact = 12,
    FormFunction = 13,
    ApiUser = 14,
    QueryAlias = 15,
    FEStandard = 16,
    BEStandard = 17,
    ClientCredential = 18,
    LegalUnit = 19,
}
